// Our usage of lodash vastly predates our use of JS modules (and webpack/babel). As such,
// a large number of older JS files assume that _ is always present on the root object (window).
// Additionally, due to a particular customer injecting an old version of underscore, we have
// to do some extra workarounds.

import _ from 'lodash';
window._ = _;
window.socrataLodash = _;
